import { render, staticRenderFns } from "./RequestAccess.vue?vue&type=template&id=8430f010&scoped=true&"
import script from "./RequestAccess.vue?vue&type=script&lang=js&"
export * from "./RequestAccess.vue?vue&type=script&lang=js&"
import style0 from "./RequestAccess.vue?vue&type=style&index=0&id=8430f010&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8430f010",
  null
  
)

export default component.exports